import {getHoursMinutes} from '@hconnect/common/utils'
import {Box, Typography} from '@mui/material'
import {OperationHoursLegendTooltip} from '@widgets/running-times'
import {FC} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type GraphLegendProps = {
  showOperationHoursLegend: boolean
  totalStopped?: string
  totalRunning?: string
}

export const GraphLegend: FC<GraphLegendProps> = ({
  showOperationHoursLegend,
  totalStopped,
  totalRunning
}) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return (
    <>
      {totalRunning && (
        <Box mr={2} data-test-id="total-running-time">
          <Typography variant="caption">{t('graphLegend.label.runningTime')}</Typography>
          <Typography component="div" sx={{fontWeight: 500}}>
            {totalRunning ? `${getHoursMinutes(totalRunning)} h` : '-'}
          </Typography>
        </Box>
      )}
      <Box data-test-id="total-stopped-time">
        <Typography variant="caption">{t('graphLegend.label.stoppageTime')}</Typography>
        <Typography component="div" sx={{fontWeight: 500}}>
          {totalStopped ? `${getHoursMinutes(totalStopped)} h` : '-'}
        </Typography>
      </Box>
      {showOperationHoursLegend && <OperationHoursLegendTooltip />}
    </>
  )
}
